'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChangeEvent, InputHTMLAttributes, MouseEvent } from 'react';
import { FieldGroup, type FieldGroupType } from '@/app/components/forms/field-group';
import { type CustomFormStyleConfig, getCustomFormStyle, inputAffixTextStyled, inputBoxStyled, inputIconStyled, inputStepperButtonStyled, inputTextStyled } from '@/app/components/forms/styles';
import { Icon, type IconType } from '@/app/components/icons';
import { IconArrowDropUp } from '@/app/components/icons/ui-actions/icon-arrow-drop-up';
import type { Theme } from '@/app/types/styles/theme';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { safeCall } from '@/app/utils/safeCall';
export interface TextFieldProps extends FieldGroupType, InputHTMLAttributes<HTMLInputElement> {
  name: string;
  placeholder?: string;
  value?: string;
  autoComplete?: string;
  iconBefore?: IconType;
  iconAfter?: IconType;
  prefix?: string;
  suffix?: string;
  spinButton?: boolean;
  spinActive?: boolean;
  spinUpDisabled?: boolean;
  spinDownDisabled?: boolean;
  onSpinUp?: (e: MouseEvent<HTMLButtonElement>) => void;
  onSpinDown?: (e: MouseEvent<HTMLButtonElement>) => void;
  theme?: Theme;
  className?: string;
  inputClassName?: string;
  groupClassName?: string;
  customStyle?: CustomFormStyleConfig;
  groupAttributes?: Record<string, string>;
}
export const TextField = t0 => {
  const $ = _c(134);
  let autoComplete;
  let className;
  let customStyle;
  let errorMessage;
  let groupClassName;
  let iconAfter;
  let iconBefore;
  let inputClassName;
  let label;
  let maxLength;
  let message;
  let name;
  let onChange;
  let onSpinDown;
  let onSpinUp;
  let placeholder;
  let prefix;
  let ref;
  let rest;
  let secondaryLabel;
  let spinButton;
  let suffix;
  let t1;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  let value;
  if ($[0] !== t0) {
    ({
      className,
      inputClassName,
      groupClassName,
      label,
      secondaryLabel,
      errorMessage,
      message,
      theme: t1,
      showMaxLength: t2,
      disabled: t3,
      required: t4,
      error: t5,
      name,
      value,
      type: t6,
      iconBefore,
      iconAfter,
      prefix,
      suffix,
      placeholder,
      autoComplete,
      maxLength,
      onChange,
      customStyle,
      spinButton,
      spinActive: t7,
      spinUpDisabled: t8,
      spinDownDisabled: t9,
      onSpinUp,
      onSpinDown,
      ref,
      groupAttributes: t10,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = autoComplete;
    $[2] = className;
    $[3] = customStyle;
    $[4] = errorMessage;
    $[5] = groupClassName;
    $[6] = iconAfter;
    $[7] = iconBefore;
    $[8] = inputClassName;
    $[9] = label;
    $[10] = maxLength;
    $[11] = message;
    $[12] = name;
    $[13] = onChange;
    $[14] = onSpinDown;
    $[15] = onSpinUp;
    $[16] = placeholder;
    $[17] = prefix;
    $[18] = ref;
    $[19] = rest;
    $[20] = secondaryLabel;
    $[21] = spinButton;
    $[22] = suffix;
    $[23] = t1;
    $[24] = t10;
    $[25] = t2;
    $[26] = t3;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
    $[33] = value;
  } else {
    autoComplete = $[1];
    className = $[2];
    customStyle = $[3];
    errorMessage = $[4];
    groupClassName = $[5];
    iconAfter = $[6];
    iconBefore = $[7];
    inputClassName = $[8];
    label = $[9];
    maxLength = $[10];
    message = $[11];
    name = $[12];
    onChange = $[13];
    onSpinDown = $[14];
    onSpinUp = $[15];
    placeholder = $[16];
    prefix = $[17];
    ref = $[18];
    rest = $[19];
    secondaryLabel = $[20];
    spinButton = $[21];
    suffix = $[22];
    t1 = $[23];
    t10 = $[24];
    t2 = $[25];
    t3 = $[26];
    t4 = $[27];
    t5 = $[28];
    t6 = $[29];
    t7 = $[30];
    t8 = $[31];
    t9 = $[32];
    value = $[33];
  }
  const theme = t1 === undefined ? "light" : t1;
  const showMaxLength = t2 === undefined ? false : t2;
  const disabled = t3 === undefined ? false : t3;
  const required = t4 === undefined ? false : t4;
  const error = t5 === undefined ? false : t5;
  const type = t6 === undefined ? "text" : t6;
  const spinActive = t7 === undefined ? false : t7;
  const spinUpDisabled = t8 === undefined ? false : t8;
  const spinDownDisabled = t9 === undefined ? false : t9;
  let t11;
  if ($[34] !== t10) {
    t11 = t10 === undefined ? {} : t10;
    $[34] = t10;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  const groupAttributes = t11;
  let t12;
  if ($[36] !== disabled || $[37] !== maxLength || $[38] !== onChange || $[39] !== value) {
    t12 = event => {
      if (disabled || value && maxLength && value.length > maxLength) {
        return;
      }
      safeCall(onChange, event);
    };
    $[36] = disabled;
    $[37] = maxLength;
    $[38] = onChange;
    $[39] = value;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  const handleChange = t12;
  let t13;
  if ($[41] !== className || $[42] !== customStyle?.textfield?.wrapper || $[43] !== disabled || $[44] !== error || $[45] !== theme) {
    t13 = cn(inputBoxStyled({
      theme,
      error,
      disabled
    }), "group flex h-12 cursor-text items-center gap-x-2 rounded-sm px-4", getCustomFormStyle(customStyle?.textfield?.wrapper, {
      error,
      disabled
    }), className);
    $[41] = className;
    $[42] = customStyle?.textfield?.wrapper;
    $[43] = disabled;
    $[44] = error;
    $[45] = theme;
    $[46] = t13;
  } else {
    t13 = $[46];
  }
  const wrapperClass = t13;
  let t14;
  if ($[47] !== customStyle?.textfield?.text || $[48] !== disabled || $[49] !== error || $[50] !== inputClassName || $[51] !== theme) {
    t14 = cn(inputTextStyled({
      theme,
      error,
      disabled
    }), "self-stretch text-ellipsis", getCustomFormStyle(customStyle?.textfield?.text, {
      error,
      disabled
    }), inputClassName);
    $[47] = customStyle?.textfield?.text;
    $[48] = disabled;
    $[49] = error;
    $[50] = inputClassName;
    $[51] = theme;
    $[52] = t14;
  } else {
    t14 = $[52];
  }
  const inputClass = t14;
  let t15;
  if ($[53] !== customStyle?.textfield?.icon || $[54] !== disabled || $[55] !== error || $[56] !== theme) {
    t15 = cn(inputIconStyled({
      theme,
      error,
      disabled
    }), getCustomFormStyle(customStyle?.textfield?.icon, {
      error,
      disabled
    }));
    $[53] = customStyle?.textfield?.icon;
    $[54] = disabled;
    $[55] = error;
    $[56] = theme;
    $[57] = t15;
  } else {
    t15 = $[57];
  }
  const iconClass = t15;
  let t16;
  if ($[58] !== customStyle?.textfield?.affix || $[59] !== disabled || $[60] !== error || $[61] !== theme) {
    t16 = cn(inputAffixTextStyled({
      theme,
      error,
      disabled
    }), getCustomFormStyle(customStyle?.textfield?.affix, {
      error,
      disabled
    }));
    $[58] = customStyle?.textfield?.affix;
    $[59] = disabled;
    $[60] = error;
    $[61] = theme;
    $[62] = t16;
  } else {
    t16 = $[62];
  }
  const affixClass = t16;
  let t17;
  if ($[63] !== customStyle?.textfield?.stepper || $[64] !== error || $[65] !== spinActive || $[66] !== theme) {
    t17 = isDisabled => cn(inputStepperButtonStyled({
      theme,
      error,
      disabled: isDisabled,
      isActive: spinActive
    }), getCustomFormStyle(customStyle?.textfield?.stepper, {
      error,
      disabled: isDisabled
    }));
    $[63] = customStyle?.textfield?.stepper;
    $[64] = error;
    $[65] = spinActive;
    $[66] = theme;
    $[67] = t17;
  } else {
    t17 = $[67];
  }
  const stepperClass = t17;
  let t18;
  if ($[68] !== iconClass) {
    t18 = icon => <Icon icon={icon} className={iconClass} />;
    $[68] = iconClass;
    $[69] = t18;
  } else {
    t18 = $[69];
  }
  const renderIcon = t18;
  const t19 = customStyle?.fieldGroup;
  const t20 = value?.length;
  const t21 = label ? ref : undefined;
  const t22 = label ? undefined : ref;
  let t23;
  if ($[70] !== iconBefore || $[71] !== renderIcon) {
    t23 = !!iconBefore && renderIcon(iconBefore);
    $[70] = iconBefore;
    $[71] = renderIcon;
    $[72] = t23;
  } else {
    t23 = $[72];
  }
  let t24;
  if ($[73] !== affixClass || $[74] !== name || $[75] !== prefix) {
    t24 = !!prefix && <span className={affixClass} {...createDataAttributes({
      test: `prefix-text-${name}`
    })}>{prefix}</span>;
    $[73] = affixClass;
    $[74] = name;
    $[75] = prefix;
    $[76] = t24;
  } else {
    t24 = $[76];
  }
  const t25 = `input-${name}`;
  let t26;
  if ($[77] !== t25) {
    t26 = createDataAttributes({
      test: t25
    });
    $[77] = t25;
    $[78] = t26;
  } else {
    t26 = $[78];
  }
  let t27;
  if ($[79] !== autoComplete || $[80] !== disabled || $[81] !== handleChange || $[82] !== inputClass || $[83] !== maxLength || $[84] !== name || $[85] !== placeholder || $[86] !== rest || $[87] !== t26 || $[88] !== type || $[89] !== value) {
    t27 = <input id={name} name={name} value={value} type={type} maxLength={maxLength} placeholder={placeholder} autoComplete={autoComplete} disabled={disabled} onChange={handleChange} className={inputClass} {...t26} {...rest} />;
    $[79] = autoComplete;
    $[80] = disabled;
    $[81] = handleChange;
    $[82] = inputClass;
    $[83] = maxLength;
    $[84] = name;
    $[85] = placeholder;
    $[86] = rest;
    $[87] = t26;
    $[88] = type;
    $[89] = value;
    $[90] = t27;
  } else {
    t27 = $[90];
  }
  let t28;
  if ($[91] !== affixClass || $[92] !== name || $[93] !== suffix) {
    t28 = !!suffix && <span className={affixClass} {...createDataAttributes({
      test: `suffix-text-${name}`
    })}>{suffix}</span>;
    $[91] = affixClass;
    $[92] = name;
    $[93] = suffix;
    $[94] = t28;
  } else {
    t28 = $[94];
  }
  let t29;
  if ($[95] !== iconAfter || $[96] !== renderIcon) {
    t29 = !!iconAfter && renderIcon(iconAfter);
    $[95] = iconAfter;
    $[96] = renderIcon;
    $[97] = t29;
  } else {
    t29 = $[97];
  }
  let t30;
  if ($[98] !== disabled || $[99] !== name || $[100] !== onSpinDown || $[101] !== onSpinUp || $[102] !== spinButton || $[103] !== spinDownDisabled || $[104] !== spinUpDisabled || $[105] !== stepperClass) {
    t30 = !!spinButton && <div className={cn("flex flex-col")}><button type="button" aria-label="Stepper Up Button" className={cn(stepperClass(disabled || spinUpDisabled))} disabled={disabled || spinUpDisabled} onClick={onSpinUp} {...createDataAttributes({
        test: `spin-up-${name}`
      })}><Icon icon={<IconArrowDropUp />} /></button><button type="button" aria-label="Stepper Down Button" className={cn(stepperClass(disabled || spinDownDisabled), "rotate-180")} disabled={disabled || spinDownDisabled} onClick={onSpinDown} {...createDataAttributes({
        test: `spin-down-${name}`
      })}><Icon icon={<IconArrowDropUp />} /></button></div>;
    $[98] = disabled;
    $[99] = name;
    $[100] = onSpinDown;
    $[101] = onSpinUp;
    $[102] = spinButton;
    $[103] = spinDownDisabled;
    $[104] = spinUpDisabled;
    $[105] = stepperClass;
    $[106] = t30;
  } else {
    t30 = $[106];
  }
  let t31;
  if ($[107] !== t22 || $[108] !== t23 || $[109] !== t24 || $[110] !== t27 || $[111] !== t28 || $[112] !== t29 || $[113] !== t30 || $[114] !== wrapperClass) {
    t31 = <div className={wrapperClass} ref={t22}>{t23}{t24}{t27}{t28}{t29}{t30}</div>;
    $[107] = t22;
    $[108] = t23;
    $[109] = t24;
    $[110] = t27;
    $[111] = t28;
    $[112] = t29;
    $[113] = t30;
    $[114] = wrapperClass;
    $[115] = t31;
  } else {
    t31 = $[115];
  }
  let t32;
  if ($[116] !== disabled || $[117] !== error || $[118] !== errorMessage || $[119] !== groupAttributes || $[120] !== groupClassName || $[121] !== label || $[122] !== maxLength || $[123] !== message || $[124] !== name || $[125] !== required || $[126] !== secondaryLabel || $[127] !== showMaxLength || $[128] !== t19 || $[129] !== t20 || $[130] !== t21 || $[131] !== t31 || $[132] !== theme) {
    t32 = <FieldGroup htmlFor={name} label={label} secondaryLabel={secondaryLabel} required={required} error={error} errorMessage={errorMessage} message={message} theme={theme} customStyle={t19} length={t20} maxLength={maxLength} showMaxLength={showMaxLength} disabled={disabled} ref={t21} className={groupClassName} {...groupAttributes}>{t31}</FieldGroup>;
    $[116] = disabled;
    $[117] = error;
    $[118] = errorMessage;
    $[119] = groupAttributes;
    $[120] = groupClassName;
    $[121] = label;
    $[122] = maxLength;
    $[123] = message;
    $[124] = name;
    $[125] = required;
    $[126] = secondaryLabel;
    $[127] = showMaxLength;
    $[128] = t19;
    $[129] = t20;
    $[130] = t21;
    $[131] = t31;
    $[132] = theme;
    $[133] = t32;
  } else {
    t32 = $[133];
  }
  return t32;
};